var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z",
    fill: "url(#paint0_linear_3570_61277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9331 6.43306C14.1771 6.18898 14.5729 6.18898 14.8169 6.43306C15.0422 6.65836 15.0596 7.01288 14.8689 7.25806L14.8169 7.31694L8.56694 13.5669C8.34164 13.7922 7.98712 13.8096 7.74194 13.6189L7.68306 13.5669L5.18306 11.0669C4.93898 10.8229 4.93898 10.4271 5.18306 10.1831C5.40836 9.95776 5.76288 9.94042 6.00806 10.1311L6.06694 10.1831L8.125 12.2406L13.9331 6.43306Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3570_61277",
    x1: -2.98023e-7,
    y1: 20,
    x2: 23.8939,
    y2: 7.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6F056"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct_icon.269bf1835a51a7ccb8e225b0eb8f6c10.svg";
export { ForwardRef as ReactComponent };